<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item label="标签名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="model.displayName" placeholder="请输入标签名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Code" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="model.code" placeholder="请输入Code"></a-input>
        </a-form-model-item>
        <a-form-model-item label="1:私有0可继承" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="permission">
          <a-radio-group v-model="model.permission">
            <a-radio value="1">私有</a-radio>
            <a-radio value="0">可继承</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- 子表单区域 -->
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="标签列定义" key="1">
            <div>
              <a-row type="flex" style="margin-bottom: 10px;" :gutter="16">
                <a-col :span="2">列名</a-col>
                <a-col :span="4">Code</a-col>
                <a-col :span="2">required</a-col>
                <a-col :span="2">permission</a-col>
                <a-col :span="3">控件类型</a-col>
                <a-col :span="3">业务编码</a-col>
                <a-col :span="3">转换任务</a-col>
                <a-col :span="2">resource</a-col>
                <a-col :span="1">操作</a-col>
              </a-row>
              <a-row
                type="flex"
                style="margin-bottom: 10px"
                :gutter="16"
                v-for="(item, index) in model.columns"
                :key="index"
              >
                <a-col :span="0" style="display: none">
                  <a-form-model-item>
                    <a-input placeholder="id" v-model="item.id" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-model-item>
                    <a-input placeholder="列名" v-model="item.name" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item>
                    <span style="width:40%;" v-show="!model.id" >{{ model.code }}</span>
                    <a-input placeholder="Code" v-model="item.code" style="width:60%" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-model-item>
                    <a-select v-model="item.required" placeholder="必填">
                      <a-select-option value="0"> 非必填 </a-select-option>
                      <a-select-option value="1"> 必填 </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-model-item>
                    <a-select v-model="item.permission" placeholder="可继承">
                      <a-select-option value="0"> 私有 </a-select-option>
                      <a-select-option value="1"> 可继承 </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="3">
                  <a-form-model-item>
                    <d-select v-model="item.controlType" placeholder="控件类型" pidValue="951885197864972288" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="3">
                  <a-form-model-item>
                    <d-select v-model="item.businessCode" placeholder="业务编码" pidValue="954030310520881152" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="3">
                  <a-form-model-item>
                    <j-dict-select-tag
                      v-model="item.jobCode"
                      placeholder="转换任务"
                      dictCode="job_job_definition,name,code"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-item>
                    <j-tree-select
                      v-model="item.resourceId"
                      dict="do_form_core_resource,name,id"
                      pid-field="pid"
                      pidValue="0"
                    >
                    </j-tree-select>
                  </a-form-item>
                </a-col>
                <a-col :span="1">
                  <a-form-model-item>
                    <a-icon type="minus-circle" @click="delRowCustom(index)" style="fontsize: 20px" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-button type="dashed" style="width: 98%; margin-top: 10px" @click="addRowCustom">
                <a-icon type="plus" /> 添加新的列定义
              </a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { checkPermission, checkRequired } from './validator'
import { doMistServerUrl } from '@/api/api'
export default {
  name: 'DoFormCoreTagModal',
  components: {},
  data() {
    return {
      title: '操作',
      width: 1280,
      visible: false,
      model: {
        columns: [],
      },
      model_before: {
        columns: [],
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {
        permission: [{ validator: checkPermission, trigger: 'blur' }],
        required: [{ validator: checkRequired, trigger: 'blur' }],
      },
      url: {
        // add: `${window._CONFIG['doBaseUrl']}/doMistServer/doFormCoreTag/add`,
        // edit: `${window._CONFIG['doBaseUrl']}/doMistServer/doFormCoreTag/edit`,

        add: `${doMistServerUrl}/tag/savePartTag`,
        edit: `${doMistServerUrl}/tag/savePartTag`,
        getColumnsByTagId: `${doMistServerUrl}/tagColumn/getColumnsByTagId`,
      },
      expandedRowKeys: [],
      pidField: 'pid',
    }
  },
  created() {
    // 备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    addRowCustom() {
      this.model.columns.push({ permission: '1', controlType: '952968087063502848' })
      this.$forceUpdate()
    },

    delRowCustom(index) {
      this.model.columns.splice(index, 1)
      this.$forceUpdate()
    },
    add(obj) {
      this.modelDefault.pid = '0'
      this.edit(Object.assign(this.modelDefault, obj))
    },
    edit(record) {
      this.model_before = record
      this.model = Object.assign({}, record, { columns: [] })
      if (this.model.id) {
        let httpurl = this.url.getColumnsByTagId
        getAction(httpurl, { tagId: this.model.id }).then((res) => {
          if (res.success) {
            let result = res.result

            this.model = Object.assign({}, record, { columns: result })
          } else {
            this.$message.warning(res.message)
          }
        })
      }

      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // return
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true

          if (this.model.id && this.model.id === this.model[this.pidField]) {
            that.$message.warning('父级节点不能选择自己')
            that.confirmLoading = false
            return
          }

          if (this.model[this.pidField] !== '0') {
            getAction(this.url.getColumnsByTagId, { tagId: this.model[this.pidField] }).then((res) => {
              if (res.success) {
                let result = res.result
                let httpurl2 = this.url.edit
                let method2 = 'post'
                httpAction(httpurl2, { id: this.model[this.pidField], hasChild: '1', columns: result }, method2).then(
                  (res) => {
                    if (res.success) {
                      this.$emit('ok')
                    } else {
                      that.$message.warning(res.message)
                    }
                  }
                )
              } else {
                this.$message.warning(res.message)
              }
            })
          }
          console.log('edit', this.model)

          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            // 新增
            for (let i = 0; i < this.model.columns.length; i++) {
              this.model.columns[i].code = this.model.code + this.model.columns[i].code
            }
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
            // this.model = Object.assign(
            //   { id: this.model.id, columns: this.model.columns },
            // this.filterDifVal(this.model_before, this.model)
            // )
          }
          // console.log("edit",this.model);
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                this.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    // filterDifVal(o1, o2) {
    //   let subset = {}
    //   let remain = JSON.parse(JSON.stringify(o2))
    //   for (let key of Object.keys(o1)) {
    //     //remain.hasOwnProperty(key) ?  (subset[key] = o1[key]):delete remain[key] ;

    //     if (remain.hasOwnProperty(key)) {
    //       if (o1[key] !== o2[key]) {
    //         subset[key] = o2[key]
    //       }
    //     }
    //   }
    //   return subset
    // },
    handleCancel() {
      this.close()
    },
    submitSuccess(formData, flag) {
      if (!formData.id) {
        let treeData = this.$refs.treeSelect.getCurrTreeData()
        this.expandedRowKeys = []
        this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
        this.$emit('ok', formData, this.expandedRowKeys.reverse())
      } else {
        this.$emit('ok', formData, flag)
      }
    },
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].key == pid) {
            this.expandedRowKeys.push(arr[i].key)
            this.getExpandKeysByPid(arr[i]['parentId'], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all)
          }
        }
      }
    },
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
